// extracted by mini-css-extract-plugin
export default {"content_script":"index-module__content_script--S3vWx"};